import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export const CallToAction = () => {
  return <section className="py-6 md:py-8 bg-gradient-to-br from-christmas-green/20 via-bttf-bg to-christmas-red/20 text-bttf-text relative overflow-hidden" id="cta" data-id="element-78">
      <div className="absolute inset-0 bg-gradient-to-br from-christmas-gold/10 to-christmas-red/10 mix-blend-overlay" data-id="element-79"></div>

      {/* Festive Background Elements */}
      <div className="absolute top-10 left-10 text-5xl opacity-10 animate-float" data-id="element-80">
        🎄
      </div>
      <div className="absolute top-20 right-20 text-4xl opacity-10 animate-float" style={{
      animationDelay: '1s'
    }} data-id="element-81">
        🎁
      </div>
      <div className="absolute bottom-10 left-1/4 text-4xl opacity-10 animate-float" style={{
      animationDelay: '2s'
    }} data-id="element-82">
        ⭐
      </div>
      <div className="absolute bottom-20 right-1/3 text-3xl opacity-10 animate-float" style={{
      animationDelay: '1.5s'
    }} data-id="element-83">
        ❄️
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-84">
        <div className="text-center mb-6" data-id="element-85">
          <div className="flex justify-center mb-2 gap-2" data-id="element-86">
            <span className="text-3xl animate-twinkle" data-id="element-87">🎅</span>
            <StarIcon className="h-8 w-8 text-christmas-gold fill-current shadow-christmas-glow" data-id="element-88" />
            <span className="text-3xl animate-twinkle" style={{
            animationDelay: '1s'
          }} data-id="element-89">
              🎅
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold font-future tracking-wide bg-gradient-festive text-transparent bg-clip-text mb-2" data-id="element-90">
            Don't Miss This Limited Christmas Offer
          </h2>
          <div className="w-20 h-1 bg-gradient-christmas mx-auto" data-id="element-91"></div>
        </div>
        <div className="max-w-3xl mx-auto text-center" data-id="element-92">
          <p className="text-xl mb-6 text-bttf-text" data-id="element-93">
            🎁 The perfect gift for any Back to the Future fan! Click below to
            claim your Christmas edition before this limited collector's run
            disappears.
          </p>
          <a href="#pricing" className="inline-flex items-center bg-gradient-christmas hover:opacity-90 text-white font-bold px-8 py-4 rounded-md text-lg transition-all transform hover:scale-105 shadow-md hover:shadow-christmas-glow border-2 border-christmas-gold/50" data-id="element-94">
            🎄 Get My Copy Now
            <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-95" />
          </a>
          <p className="mt-4 text-sm text-christmas-gold animate-twinkle" data-id="element-96">
          </p>
        </div>
      </div>
    </section>;
};
const StarIcon = ({
  className
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-97">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" data-id="element-98"></polygon>
  </svg>;